import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import AppContext from 'context/Context';
import { Spinner } from 'react-bootstrap';

const NewBusinessAnalysisTable = ({
  times,
  loading,
  data,
  formatHeader,
  targetValue
}) => {
  const [dataTable, setDataTable] = useState([]);
  const [totalRow, setTotalRow] = useState({});
  const [targetRow, setTargetRow] = useState({});

  useEffect(() => {
    if (!data) {
      return;
    }
    console.log(data);
    const transformedData = data.map(item => {
      const flattened = {
        customer: item.customer,
        fpw: item.fpw,
        id: item.id
      };

      let sum = 0;
      let count = 0;

      times.forEach(key => {
        console.log(item.data, key);
        const val = item.data?.[key] ?? 0;
        flattened[key] = val;
        if (typeof val === 'number') {
          sum += val;
          if (val > 0) {
            count += 1;
          }
        }
      });

      flattened.avg = count > 0 ? parseFloat(sum / count).toFixed(2) : 0;
      return flattened;
    });

    setDataTable(transformedData);
  }, [data]);

  useEffect(() => {
    times.forEach(key => {
      totalRow[key] = parseFloat(
        dataTable.reduce((acc, curr) => acc + (curr[key] || 0), 0).toFixed(2)
      );
    });
    totalRow.customer = 'TOTAL';
    const validValues = times.map(m => totalRow[m]).filter(val => val > 0);

    totalRow.avg = (
      validValues.reduce((acc, val) => acc + val, 0) / validValues.length || 0
    ).toFixed(2);

    setTotalRow({ ...totalRow });

    times.forEach((key,i) => {
      targetRow[key] = targetValue * (i + 1);
    });
    targetRow.customer = 'Target';
    targetRow.avg = targetValue;
    setTargetRow({ ...targetRow });
  }, [dataTable]);

  const {
    config: { isDark }
  } = useContext(AppContext);

  const baseCellStyle = {
    color: isDark ? 'white' : 'black',
    textAlign: 'center',
    padding: '10px',
    border: '1px solid #dee2e6'
  };

  const columns = [
    {
      accessor: 'customer',
      Header: 'Customer',
      Cell: value => {
        return `${value.value} FPW`;
      },
      cellProps: { style: { ...baseCellStyle } },
      headerProps: {
        style: {
          ...baseCellStyle,
          border: 'none'
        }
      }
    },
    ...times.map(time => ({
      accessor: time,
      Header: formatHeader(time),
      Cell: ({ value }) => (value === 0 ? 'N/A' : value || 0),
      cellProps: { style: baseCellStyle },
      headerProps: {
        style: {
          ...baseCellStyle,
          border: 'none'
        }
      }
    })),
    {
      accessor: 'avg',
      Header: 'AVG FPW',
      Cell: ({ value }) => value || 0,
      cellProps: { style: baseCellStyle },
      headerProps: {
        style: {
          ...baseCellStyle,
          border: 'none'
        }
      }
    }
  ];

  return (
    <Table
      responsive
      className="table-bordered"
      style={{
        backgroundColor: !isDark ? '#edf2f9' : '#0B1727'
      }}
    >
      <thead>
        <tr>
          {columns.map((col, idx) => (
            <th key={idx} style={col.headerProps?.style || baseCellStyle}>
              {col.Header}
            </th>
          ))}
        </tr>
      </thead>
      {loading && [
        <tr key="table-row-loading" className="text-center">
          <td colSpan={columns.length}>
            <Spinner
              variant="primary"
              animation="border"
              role="status"
            ></Spinner>
          </td>
        </tr>
      ]}
      {!loading && (
        <>
          <tbody>
            {dataTable?.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => {
                  const value = row[col.accessor];
                  const backgroundColor = value > 0 ? '#f2e9f2' : '';
                  return (
                    <td
                      key={colIndex}
                      style={{
                        ...col.cellProps?.style,
                        backgroundColor
                      }}
                    >
                      {col.Cell ? col.Cell({ value, row }) : value}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              {columns.map((col, colIndex) => {
                const value = totalRow[col.accessor];
                return (
                  <td
                    key={colIndex}
                    style={{
                      ...col.cellProps?.style,
                      fontWeight: 'bold',
                      backgroundColor: '#d1ecf1'
                    }}
                  >
                    {col.Cell ? col.Cell({ value, row: totalRow }) : value}
                  </td>
                );
              })}
            </tr>
            <tr>
              {columns.map((col, colIndex) => {
                const value = targetRow[col.accessor];
                return (
                  <td
                    key={colIndex}
                    style={{
                      ...col.cellProps?.style,
                      fontWeight: 'bold',
                      backgroundColor: '#d1ecf1'
                    }}
                  >
                    {col.Cell ? col.Cell({ value, row: targetRow }) : value}
                  </td>
                );
              })}
            </tr>
          </tfoot>
        </>
      )}
    </Table>
  );
};

NewBusinessAnalysisTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  times: PropTypes.array,
  formatHeader: PropTypes.func,
  targetValue: PropTypes.number
};

export default NewBusinessAnalysisTable;
